import React from 'react'


export default function Home() {

  return (
    <>
      <div className='container-fluid px-0 min-vh-100 d-flex align-items-center'>
        <div>
          <img src="../../images/building-under-construction-site-free-vector.jpg" className='img-fluid' alt="under construction" />
          <div className='container'>
            <h2 className='text-center fw-bold mt-5 mb-3'>Ready to take on the challenge? Our games 🎮 are waiting for you!</h2>
            <h3 className='text-center fw-bold'>Let the games begin - are you ready to play?</h3>
          </div>
        </div>
      </div>
    </>
  )
}
